$('body').on('click', '.product-preview .switcher .add, .product .switcher .add', function () {
    var $this = $(this);
    var switcher = $this.parents('.switcher');
    switcher.addClass('processing');

    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            '_method': 'PUT',
            'qty': 1
        },
        dataType: 'json',
        success: function (data) {
            switcher.removeClass('processing');

            if (!data.success) {
                showNotice('Error', data.message, 'Close');
                return false;
            }

            if (data.order_product) {
                $('.selected', switcher).html(data.order_product.qty);
            }

            if (data.cart) {
                updateCart(data.cart);
            }

            return false;
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    // var amount = parseInt(switcher.find('.selected').html());
    // amount++;
    // switcher.find('.selected').html(amount);

    return false;
});


$('body').on('click', '.product-preview .switcher .minus, .product .switcher .minus', function () {
    var $this = $(this);
    var switcher = $this.parents('.switcher');
    var amount = parseInt(switcher.find('.selected').html());
    
    if (amount >= 1) {
        amount--;
        switcher.addClass('processing');
        
        $.ajax({
            type: 'POST',
            url: $this.attr('href'),
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                '_method': 'PUT',
                'qty': 1
            },
            dataType: 'json',
            success: function (data) {
                switcher.removeClass('processing');
                
                if (!data.success) {
                    showNotice('Error', data.message, 'Close');
                    return false;
                }

                if (data.order_product) {
                    $('.selected', switcher).html(data.order_product.qty);
                }

                if (data.cart) {
                    updateCart(data.cart);
                }
                return false;
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });
    }
    // switcher.find('.selected').html(amount);

    return false;
});